import * as sections from "components/Homeowner/CaseForms/ComparableGrid/Sections/Sections";
import { get } from "lodash";

export const mapChaseServicingPostAdjustment = (o, item) => {
  o.location.locationRatingAdjustmentAmount = item[sections.LOCATION_RATING]["right"].value;
  o.location.locationTypeAdjustmentAmount = item[sections.LOCATION_TYPE]["right"].value;
  o.location.locationType2AdjustmentAmount = item[sections.LOCATION_TYPE_2]["right"].value;
  o.site.landAreaSquareFeetAdjustmentAmount = item[sections.SITE]["right"].value;
  o.condition.conditionAdjustmentAmount = item[sections.CONDITION]["right"].value;
  o.dateOfSaleTime.summaryAdjustmentAmount = item[sections.DATE_OF_SALE_TIME]["right"].value;
  o.dateOfSaleTime.saleDateAdjustmentAmount = item[sections.SALE_DATE_1004P]["right"].value;
  o.dateOfSaleTime.contractDateAdjustmentAmount = item[sections.CONTRACT_DATE]["right"].value;
  o.design.summaryAdjustmentAmount = item[sections.DESIGN_STYLE]["right"].value;
  o.quality.qualityRatingAdjustmentAmount = item[sections.QUALITY]["right"].value;
  o.grossLivingArea.grossLivingAreaAdjustmentAmount = item[sections.GLA]["right"].value;
  o.aboveGradeRooms.summaryAdjustmentAmount = item[sections.ABOVE_GRADE_ROOM_COUNT]["right"].value;
  o.aboveGradeRooms.totalRoomCountAdjustmentAmount = item[sections.TOTAL]["right"].value;
  o.aboveGradeRooms.bedroomCountAdjustmentAmount = item[sections.BEDROOMS]["right"].value;
  o.aboveGradeRooms.fullBathroomCountAdjustmentAmount = item[sections.BATHROOMS]["right"].value;
  o.aboveGradeRooms.halfBathroomCountAdjustmentAmount = item[sections.HALF_BATHROOMS]["right"].value;
  o.garageCarport.drivewayTypeAdjustmentAmount = item[sections.DRIVEWAY_ENABLED]["right"].value;
  o.garageCarport.drivewayCarCapacityAdjustmentAmount = item[sections.NUM_OF_CARS_MVALUE]["right"].value;
  o.garageCarport.carStorageTypeAdjustmentAmount1 = item[sections.CAR_STORAGE_1_MVALUE]["right"].value;
  o.garageCarport.carStorageAttachmentTypeAdjustmentAmount1 = item[sections.ATTACHMENT_TYPE_1_MVALUE]["right"].value;
  o.garageCarport.carStorageCarCapacityAdjustmentAmount1 = item[sections.NUM_OF_CARS_1_MVALUE]["right"].value;
  o.garageCarport.carStorageTypeAdjustmentAmount2 = item[sections.CAR_STORAGE_2_MVALUE]["right"].value;
  o.garageCarport.carStorageAttachmentTypeAdjustmentAmount2 = item[sections.ATTACHMENT_TYPE_2_MVALUE]["right"].value;
  o.garageCarport.carStorageCarCapacityAdjustmentAmount2 = item[sections.NUM_OF_CARS_2_MVALUE]["right"].value;
  o.belowGrade.totalSquareFeetAdjustmentAmount = item[sections.BELOW_GRADE_TOT_SF]["right"].value;
  o.belowGrade.finishedSquareFeetAdjustmentAmount = item[sections.BELOW_GRADE_FIN_SF]["right"].value;
  o.belowGrade.basementExitTypeAdjustmentAmount = item[sections.BASEMENT_EXIT_TYPE]["right"].value;
  o.netAdjustmentsAmount = item[sections.NET_ADJ]["right"].value;
  o.grossAdjustmentsAmount = item[sections.ADJ_NET_PRICE]["right"].value;
  o.location.summaryAdjustmentAmount = item[sections.LOCATION]["right"].value;
  o.saleFinancingConcessions.summarySaleAdjustmentAmount = item[sections.SALE_OR]["right"].value;
  o.saleFinancingConcessions.concessionAdjustmentAmount = item[sections.SALE_OR]["right"].value;
  o.site.summaryAdjustmentAmount = item[sections.SITE]["right"].value;
  o.quality.summaryAdjustmentAmount = item[sections.QUALITY]["right"].value;
  o.condition.summaryAdjustmentAmount = item[sections.CONDITION]["right"].value;
  o.grossLivingArea.summaryAdjustmentAmount = item[sections.GLA]["right"].value;
  o.belowGrade.summaryAdjustmentAmount = item[sections.BASEMENT_FINISHED]["right"].value;
  o.garageCarport.summaryAdjustmentAmount = item[sections.GARAGE_CARPORT_MVALUE]["right"].value;
  o.actualAge.summaryAdjustmentAmount = item[sections.ACTUAL_AGE_MVALUE]["right"].value;
  o.other.otherTypeAdjustmentAmount = item[sections.OTHER_MVALUE]["right"].value;
  o.location.locationType1OtherAdjustmentAmount = item[sections.LOCATION_TYPE_1_OTHER]["right"].value;
  o.location.locationType2OtherAdjustmentAmount = item[sections.LOCATION_TYPE_2_OTHER]["right"].value;
  o.primaryPhotoId = item[sections.PRIMARY_PHOTO]["right"].value;
  o.view.summaryAdjustmentAmount = item[sections.VIEW].right.value;
  o.view.viewRatingAdjustmentAmount = item[sections.VIEW_RATING]["right"].value;
  o.view.viewTypeAdjustmentAmount = item[sections.VIEW_TYPE]["right"].value;
};

export const mapChaseServicingPostDesc = (o, item, dir) => {
  o.addressLine1 = item[sections.ADDRESS][dir].value;
  o.geocodeLatitude = item[sections.LATITUDE][dir].value;
  o.geocodeLongitude = item[sections.LONGITUDE][dir].value;
  o.addressLine2 = item[sections.ADDRESS_2][dir].value;
  o.addressCity = item[sections.CITY][dir].value;
  o.addressState = item[sections.STATE][dir].value;
  o.addressPostalCode = item[sections.ZIP][dir].value;
  o.salePrice = item[sections.SALE_PRICE][dir].value;
  o.salePricePerGrossLivingArea = item[sections.SALE_PRICE_GLA][dir].value;
  o.location.summary = item[sections.LOCATION][dir].value;
  o.location.locationRating = item[sections.LOCATION_RATING][dir].value;
  o.location.locationType = item[sections.LOCATION_TYPE][dir].value;
  o.location.locationType2 = item[sections.LOCATION_TYPE_2][dir].value;
  o.location.locationType1Other = item[sections.LOCATION_TYPE_1_OTHER][dir].value;
  o.location.locationType2Other = item[sections.LOCATION_TYPE_2_OTHER][dir].value;
  o.saleFinancingConcessions.summarySale = item[sections.SALE_OR][dir].value;
  o.saleFinancingConcessions.summaryFinancing = item[sections.FINANCING_CONCESSIONS][dir].value;
  o.saleFinancingConcessions.saleType = item[sections.SALE_1004P][dir].value;
  o.saleFinancingConcessions.financingType = item[sections.FINANCING_TYPE][dir].value;
  o.saleFinancingConcessions.concessionAmount = item[sections.CONCESSION_AMOUNT][dir].value;
  o.saleFinancingConcessions.concessionOtherAmount = item[sections.CONCESSION_IF_OTHER][dir].value;
  o.site.summary = item[sections.SITE][dir].value;
  o.site.landAreaSquareFeet = Number(item[sections.SQUARE_FEET][dir].value).toFixed(0);
  o.site.landAreaAcres = Number(item[sections.ACRES][dir].value).toFixed(2);
  o.condition.conditionRating = item[sections.CONDITION][dir].value;
  o.dateOfSaleTime.statusType = item[sections.STATUS_TYPE][dir].value;
  o.dateOfSaleTime.summary = item[sections.DATE_OF_SALE_TIME][dir].value;
  o.dateOfSaleTime.saleDate = item[sections.SALE_DATE_1004P][dir].value;
  o.dateOfSaleTime.contractDate = item[sections.CONTRACT_DATE][dir].value;
  o.design.summary = item[sections.DESIGN_STYLE][dir].value;
  o.design.attachedDetached = item[sections.ATT_DET][dir].value;
  o.design.stories = item[sections.STORIES][dir].value;
  o.design.designStyle = item[sections.DESIGN][dir].value;
  o.grossLivingArea.grossLivingArea = item[sections.GLA][dir].value;
  o.belowGrade.summary = item[sections.BASEMENT_FINISHED][dir].value;
  o.belowGrade.totalSquareFeet = item[sections.BELOW_GRADE_TOT_SF][dir].value;
  o.belowGrade.finishedSquareFeet = item[sections.BELOW_GRADE_FIN_SF][dir].value;
  o.belowGrade.basementExitType = item[sections.BASEMENT_EXIT_TYPE][dir].value;
  o.garageCarport.summary = item[sections.GARAGE_CARPORT_MVALUE][dir].value;
  o.garageCarport.drivewayType = item[sections.DRIVEWAY_ENABLED][dir].value;
  o.garageCarport.drivewayCarCapacity = item[sections.NUM_OF_CARS_MVALUE][dir].value;
  o.garageCarport.carStorageType1 = item[sections.CAR_STORAGE_1_MVALUE][dir].value;
  o.garageCarport.carStorageAttachmentType1 = item[sections.ATTACHMENT_TYPE_1_MVALUE][dir].value;
  o.garageCarport.carStorageCarCapacity1 = item[sections.NUM_OF_CARS_1_MVALUE][dir].value;
  o.garageCarport.carStorageType2 = item[sections.CAR_STORAGE_2_MVALUE][dir].value;
  o.garageCarport.carStorageAttachmentType2 = item[sections.ATTACHMENT_TYPE_2_MVALUE][dir].value;
  o.garageCarport.carStorageCarCapacity2 = item[sections.NUM_OF_CARS_2_MVALUE][dir].value;
  o.quality.qualityRating = item[sections.QUALITY][dir].value;
  o.aboveGradeRooms.totalRoomCount = item[sections.TOTAL][dir].value;
  o.aboveGradeRooms.bedroomCount = item[sections.BEDROOMS][dir].value;
  o.aboveGradeRooms.fullBathroomCount = item[sections.BATHROOMS][dir].value;
  o.aboveGradeRooms.halfBathroomCount = item[sections.HALF_BATHROOMS][dir].value;
  o.proximityToSubjectMiles = get(item[sections.PROXIMITY_TO_SUBJECT][dir], ["value", "postValue"]);
  o.dataSources = item[sections.DATA_SOURCES_1004P][dir].value;
  o.netAdjustmentsPercentage = item[sections.ADJ_NET_PRICE][dir].value;
  o.grossAdjustmentsPercentage = item[sections.ADJ_GROSS_PRICE][dir].value;
  o.actualAge.ageYears = item[sections.ACTUAL_AGE_MVALUE][dir].value;
  o.other.otherType = item[sections.OTHER_MVALUE][dir].value;
  o.comparableType = item[sections.COMPARABLE_TYPE][dir].value;
  o.primaryPhotoId = item[sections.PRIMARY_PHOTO][dir].value;
  o.view.summary = item[sections.VIEW][dir].value;
  o.view.viewRating = item[sections.VIEW_RATING][dir].value;
  o.view.viewType = item[sections.VIEW_TYPE][dir].value;
  o.view.viewType2 = item[sections.VIEW_TYPE_2][dir].value;
};